import { useEffect, useMemo, useState } from 'react'
import { numberFormat } from '../../../helper'
import { webSocketWorkerEvent } from '../../../services'

const useAgGridActivityBlotter = ({ priceRatesNormalize }) => {
  const [activityBlotterResponse, setActivityBlotterResponse] = useState({
    clients: [],
    market_makers: []
  })

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.type === 'get_activity_blotter') {
        const addPnlToActivityBlotter = (counterParties, counterPartyPnl) => {
          const counterPartyMap = new Map()
          for (const counterParty of counterParties) {
            const { account: counterparty_account } = counterParty
            counterParty.pnl = 0
            counterPartyMap.set(counterparty_account, counterParty)
          }

          for (const { account: counterparty_account_pnl, account_symbol_pnl } of counterPartyPnl) {
            const counterParty = counterPartyMap.get(counterparty_account_pnl)
            if (account_symbol_pnl !== null && counterParty.pnl !== null) {
              counterParty.pnl += account_symbol_pnl
            } else {
              counterParty.pnl = null
            }
          }
        }

        addPnlToActivityBlotter(message.data.data.clients, message.data.data.clients_pnl)
        addPnlToActivityBlotter(
          message.data.data.market_makers,
          message.data.data.market_makers_pnl
        )
        message.data.data.clients = message.data.data.clients.sort((a, b) => b.trades - a.trades)
        message.data.data.market_makers = message.data.data.market_makers.sort(
          (a, b) => b.trades - a.trades
        )
        setActivityBlotterResponse(message.data.data)
      }
    }

    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [priceRatesNormalize])

  const defaultColDef = useMemo(
    () => ({
      fontSize: '14px',
      resizable: true,
      wrapText: false,
      flex: 1,
      autoHeight: false
    }),
    []
  )

  const columnsDefs = [
    {
      headerName: 'Account',
      field: 'account'
    },
    {
      headerName: 'Trades',
      field: 'trades'
    },
    {
      headerName: 'Volume (mm)',
      field: 'quantity',
      valueFormatter: params => {
        return `${numberFormat(params.data.quantity / 10 ** 6, 5)}`
      }
    },
    {
      headerName: 'P&L (USD)',
      field: 'pnl',
      valueFormatter: params => {
        return `${numberFormat(params.data.pnl)}`
      }
    }
  ]

  return { columnsDefs, defaultColDef, activityBlotterResponse }
}

export default useAgGridActivityBlotter
